"use client";

import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";
import {
  Container,
  Content,
  ContentWrapper,
  Title,
  Subtitle,
  CategoryGrid,
  CardIcon,
  CardTitle,
  CardDescription,
  QuickLinksSection,
  QuickLinksTitle,
  QuickLinksList,
  ContactSection,
  ContactTitle,
  ContactText,
  CategoryCard,
  QuickLink,
  ContactButton,
} from "./page.styles";

export default function HelpPage() {
  return (
    <Container>
      <PublicHeader />

      <Content>
        <ContentWrapper>
          <Title>Help Center</Title>
          <Subtitle>
            Find answers, get support, and learn how to make the most of Drizl
          </Subtitle>

          <CategoryGrid>
            <CategoryCard href="/faq">
              <CardIcon>❓</CardIcon>
              <CardTitle>FAQ</CardTitle>
              <CardDescription>
                Common questions and quick answers
              </CardDescription>
            </CategoryCard>

            <CategoryCard href="/how-it-works">
              <CardIcon>📖</CardIcon>
              <CardTitle>How It Works</CardTitle>
              <CardDescription>
                Step-by-step guide for customers and artisans
              </CardDescription>
            </CategoryCard>

            <CategoryCard href="/safety">
              <CardIcon>🛡️</CardIcon>
              <CardTitle>Safety Guidelines</CardTitle>
              <CardDescription>
                Food safety and community standards
              </CardDescription>
            </CategoryCard>

            <CategoryCard href="/artisan-faq">
              <CardIcon>👨‍🍳</CardIcon>
              <CardTitle>Artisan FAQ</CardTitle>
              <CardDescription>Specific help for home artisans</CardDescription>
            </CategoryCard>
          </CategoryGrid>

          <QuickLinksSection>
            <QuickLinksTitle>Popular Topics</QuickLinksTitle>
            <QuickLinksList>
              <QuickLink href="/faq#orders">→ How to place an order</QuickLink>
              <QuickLink href="/faq#payments">
                → Payment methods and refunds
              </QuickLink>
              <QuickLink href="/faq#delivery">
                → Delivery and pickup options
              </QuickLink>
              <QuickLink href="/artisan-faq#getting-started">
                → Becoming an artisan
              </QuickLink>
              <QuickLink href="/artisan-faq#earnings">
                → How artisan payments work
              </QuickLink>
              <QuickLink href="/safety#food">
                → Food safety requirements
              </QuickLink>
              <QuickLink href="/terms">→ Terms & Conditions</QuickLink>
              <QuickLink href="/privacy">→ Privacy Policy</QuickLink>
            </QuickLinksList>
          </QuickLinksSection>

          <ContactSection>
            <ContactTitle>Still Need Help?</ContactTitle>
            <ContactText>
              Can&apos;t find what you&apos;re looking for? Our support team is
              here to assist you with any questions or concerns.
            </ContactText>
            <ContactButton href="/contact">Contact Support</ContactButton>
          </ContactSection>
        </ContentWrapper>
      </Content>

      <Footer />
    </Container>
  );
}
